// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpSecondaryTabObligatorio extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.secondary_tab.obligatorio";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpSecondaryTabObligatorio {
        this.VALUES ??= this.completar({
            "valor": {
                "ca-ES": "Obligatori",
                "cz": "Povinné",
                "da": "Obligatorisk",
                "de": "Obligatorisch",
                "en": "Mandatory",
                "es": "Obligatorio",
                "eu-ES": "Beharrezkoa",
                "fi": "Pakollinen",
                "fr": "Obligatoire",
                "ga-ES": "Obrigatorio",
                "hi": "अनिवार्य",
                "hu": "Kötelező",
                "it": "Obbligatorio",
                "nl": "Verplicht",
                "no": "Obligatorisk",
                "pl": "Obowiązkowe",
                "pt": "Obrigatório",
                "ro": "Obligatoriu",
                "ru": "Обязательно",
                "sv": "Obligatorisk",
                "sk": "Povinné"
            },
            "defecto": "Mandatory"
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
